import * as React from 'react'
import './index.scss'
import { TabButtonProps } from './types'
import { Icon } from '@petz/ds-icon'

export const TabButton: React.FC<TabButtonProps> = ({ title, isActive, onClick }) => {
  return (
    <button className={`self-service-tab-button ${isActive ? 'active' : 'inactive'}`} onClick={onClick}>
      {isActive ? (
        <div className="tab-button-icon">
          <Icon name="check" variant="line" size="md" />
        </div>
      ) : null}
      <p className="tab-button-title">{title}</p>
      <div className="tab-mobile-active" />
    </button>
  )
}
